import { render, staticRenderFns } from "./flowChart2.vue?vue&type=template&id=65981470&scoped=true&"
import script from "./flowChart2.vue?vue&type=script&lang=js&"
export * from "./flowChart2.vue?vue&type=script&lang=js&"
import style0 from "./flowChart2.vue?vue&type=style&index=0&id=65981470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65981470",
  null
  
)

export default component.exports